/**
 * Employee Incident List Service
 * HTTP operations for self-service incident listing ("Mis incidentes")
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type { LC_ListIncidentsIn, LC_ListIncidentsOut, IncidentListResult } from '../types';
import { mapIncidentListResponse } from '../mappers';

/**
 * Service for self-service employee incident listing operations
 */
export class EmployeeIncidentListService {
  /**
   * List employee incidents with filters and pagination
   * GET /v{version}/employees/{employeeId}/attendances/incidents
   */
  async list(params: LC_ListIncidentsIn): Promise<ApiResponse<IncidentListResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.LIST(params.employeeId);

    const queryString = buildQueryString({
      startDate: params.startDate,
      endDate: params.endDate,
      errorTypeId: params.errorTypeId,
      status: params.status && params.status !== 'todos' ? params.status : null,
      orderBy: params.orderBy,
      orderDirection: params.orderDirection,
      page: params.page,
      pageSize: params.pageSize,
      searchText: params.searchText,
    });

    const response = await apiClient.get<LC_ListIncidentsOut>(`${endpoint}${queryString}`);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const result = mapIncidentListResponse(response.data);
    return { ...response, data: result };
  }
}

export const employeeIncidentListService = new EmployeeIncidentListService();
